import { useTranslation } from 'react-i18next';
import PersonaConfig from '../settings/PersonaConfig';
import CatalogConfig from '../settings/CatalogConfig';
import './Admin.css';

export default function PersonaSettings() {
  const { t } = useTranslation();

  return (
    <div className="admin-stack">
      <section className="admin-section" aria-labelledby="persona-heading">
        <header className="admin-section-header">
          <h2 id="persona-heading" className="admin-section-title">
            {t('settings.personaTitle', 'nyxCore Persona Studio')}
          </h2>
          <p className="admin-section-desc">
            {t(
              'settings.personaDesc',
              'Eigener Token (nyx_pa_…) für Persona-Kreise. Bei aktiver Persona läuft der Chat über nyxCore-gehostete LLMs (BYOK auf Tenant-Seite, Abrechnung pro Token).'
            )}
          </p>
        </header>
        <PersonaConfig />
      </section>

      <section className="admin-section" aria-labelledby="catalog-heading">
        <header className="admin-section-header">
          <h2 id="catalog-heading" className="admin-section-title">
            {t('settings.catalogTitle')}
          </h2>
          <p className="admin-section-desc">{t('settings.catalogDesc')}</p>
        </header>
        <CatalogConfig />
      </section>
    </div>
  );
}
